import { Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import api from '../../../api';
import { ID } from '../../../global';
import { Page, PageParam } from '@/models/common';
import { Staff, StaffEndpoint } from '@/models/staff';
import { createModalSelector } from '../core/createModalSelector';
import { createModalViewer } from '../core/createModalViewer';
import { createSelector } from '../core/createSelector';
import { DataSource } from '../core/datasource';

type StaffFilterValue = { nickname: string };
export const StaffFilter: React.FC<{ onFilter: (filters: StaffFilterValue) => void }> = ({
  onFilter,
}) => {
  const [form] = Form.useForm();
  return (
    <Form<StaffFilterValue> form={form} layout="inline" onFinish={onFilter}>
      <Form.Item name="nickname" label="员工昵称">
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          搜索
        </Button>
      </Form.Item>
    </Form>
  );
};

let cachedStaffList: Staff[];

class StaffDataSource extends DataSource<Staff, StaffFilterValue> {
  getKey(entity: Staff): ID {
    return entity.username;
  }
  getLabel(staff: Staff): React.ReactNode {
    return <>{staff.nickname}</>;
  }
  getValue(entity: Staff): ID {
    return entity.username;
  }
  getEntity(id: ID): Promise<Staff> {
    throw new Error('Method not implemented.');
  }
  async getList({ pageParam, filter }: { pageParam?: PageParam; filter?: StaffFilterValue } = {}) {
    if (cachedStaffList && cachedStaffList.length) return cachedStaffList;
    const rsp = await api.get<{
      list: Staff[];
      page: Page;
    }>({
      url: `${StaffEndpoint}`,
      params: { ...pageParam, ...filter },
    });
    this.pageInfo = rsp.page;
    return (cachedStaffList = rsp.list);
  }
  async getViewList({
    pageParam,
    filter,
    value,
  }: {
    pageParam?: PageParam;
    filter?: StaffFilterValue;
    value: ID[];
  }) {
    const rsp = await api.post<{
      list: Staff[];
      page: Page;
    }>({
      url: `${StaffEndpoint}/selector`,
      params: { ...pageParam, ...filter },
      data: value,
    });

    this.pageInfo = rsp.page;
    return rsp.list;
  }
  getPageInfo(): Page {
    return this.pageInfo;
  }
}

class OperatorDataSource extends StaffDataSource {
  async getList(args: { pageParam?: PageParam; filter?: StaffFilterValue }) {
    const list = await super.getList(args);
    return list.filter(v => v.isOperator);
  }
}

/**
 * 员工
 */
export const StaffSelector = createSelector({ datasource: new StaffDataSource() });
export const StaffModalViewer = createModalViewer({
  datasource: new StaffDataSource(),
  tableColumns: [
    { title: '员工名', dataIndex: 'nickname' },
    { title: '账号', dataIndex: 'username' },
  ],
});
export const StaffModalViewerWithTrigger = ({
  ids,
  children,
  title,
}: {
  ids: number[];
  children: React.ReactChild;
  title: React.ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <StaffModalViewer
          title={title}
          open={open}
          value={ids}
          onCancel={() => {
            setOpen(false);
          }}
        />
      )}
      {React.cloneElement(children as React.ReactElement, { onClick: () => setOpen(true) })}
    </>
  );
};

/**
 * 美容师
 */
export const OperatorSelector = createSelector({ datasource: new OperatorDataSource() });

export const OperatorModalSelector = createModalSelector({
  datasource: new OperatorDataSource(),
  tableColumns: [
    { title: '员工名', dataIndex: 'nickname' },
    { title: '账号', dataIndex: 'username' },
  ],
  Filter: StaffFilter,
});
